/* eslint-disable */
import axios from "axios";

export const base = process.env.VUE_APP_BASE_URL_PSC_BIOMETRIC

export const county_logo = base +"/logos/logo.png"
export const login_bg = base +"/logos/bg-auth-overlay.png"
export const paysol =  base+"/paysol/index.php";
export const authUrl =  base+"/index.php";

export const uploads =  base;



// Toast notification utility
export const toast = {
    success(message) {
        this._showToast(message, 'success');
    },
    error(message) {
        this._showToast(message, 'error');
    },
    warning(message) {
        this._showToast(message, 'warning');
    },
    info(message) {
        this._showToast(message, 'info');
    },
    _showToast(message, type) {
        // Create toast element
        const toast = document.createElement('div');
        toast.className = `toast-notification toast-${type}`;
        toast.style.cssText = `
      position: fixed;
      min-width: 250px;
      margin-bottom: 10px;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      transform: translateY(30px);
      opacity: 0;
      transition: all 0.3s ease;
      z-index: 9999;
      color: white;
    `;

        // Apply color based on type
        switch(type) {
            case 'success':
                toast.style.backgroundColor = '#4caf50';
                break;
            case 'error':
                toast.style.backgroundColor = '#f44336';
                break;
            case 'warning':
                toast.style.backgroundColor = '#ff9800';
                break;
            case 'info':
                toast.style.backgroundColor = '#2196f3';
                break;
        }

        toast.innerHTML = `
      <div style="display: flex; align-items: center;">
        <div style="flex-grow: 1;">${message}</div>
      </div>
    `;

        // Add to DOM
        const container = document.getElementById('toast-container') || this._createContainer();
        container.appendChild(toast);

        // Trigger animation
        setTimeout(() => {
            toast.style.transform = 'translateY(0)';
            toast.style.opacity = '1';
        }, 10);

        // Auto-remove after 3 seconds
        setTimeout(() => {
            toast.style.transform = 'translateY(30px)';
            toast.style.opacity = '0';
            setTimeout(() => {
                if (container.contains(toast)) {
                    container.removeChild(toast);
                }
                // Remove container if empty
                if (container.children.length === 0 && document.body.contains(container)) {
                    document.body.removeChild(container);
                }
            }, 300);
        }, 3000);
    },
    _createContainer() {
        const container = document.createElement('div');
        container.id = 'toast-container';
        container.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 9999;
    `;
        document.body.appendChild(container);
        return container;
    }
};

export const execute = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}})
}

export const executeJson = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url, params, {
        headers: {
            "Authorization": `Bearer ${tokenStr}`,
            "Content-Type": "application/json"
        }
    });
}

export const executeDownload = (params, url) => {
    const tokenStr = sessionStorage.getItem("tokenSession");
    return axios.post(url,params,{headers: {"Authorization": `Bearer ${tokenStr}`}, responseType: 'blob'})
}

export const execute2 = (params, url) => {
    return axios.post(url,params)
}

export const getRight = (accessRole) => {
    // Get the string from sessionStorage and parse it into an array
    const selectedRolesString = sessionStorage.getItem("selectedRoles");

    if (!selectedRolesString) {
        return false;
    }

    try {
        const selectedRoles = JSON.parse(selectedRolesString);

        if (!Array.isArray(selectedRoles)) {
            return false;
        }

        let accessRight = false;

        for (const role of selectedRoles) {
            // Check role_name property (not role)
            if (role.role_name === accessRole) {
                accessRight = true;
                break;
            }
        }

        return accessRight;
    } catch (error) {
        console.error("Error parsing selectedRoles:", error);
        return false;
    }

    return true;
};